"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayLogicType = exports.DEFAULT_DISPLAY_LOGIC_CONFIG = void 0;
exports.DEFAULT_DISPLAY_LOGIC_CONFIG = 'env';
var DisplayLogicType;
(function (DisplayLogicType) {
    DisplayLogicType["BASIC"] = "basic";
    DisplayLogicType["ADVANCED"] = "advanced";
})(DisplayLogicType = exports.DisplayLogicType || (exports.DisplayLogicType = {}));
